import React from 'react';
import PropTypes from 'prop-types';

import ConfirmDialog from './confirm-dialog';

/**
 * Preset copy and test IDs for cancel-subscription flows (account list + artist page).
 */
const CancelSubscriptionConfirmDialog = ({
	artistName,
	isOpen,
	onConfirm,
	onClose,
	...rest
}) => (
	<ConfirmDialog
		isOpen={ isOpen }
		title="Cancel subscription?"
		message={ `Cancel your subscription to ${ artistName }? This cannot be undone.` }
		confirmLabel="Cancel subscription"
		cancelLabel="Keep subscription"
		variant="danger"
		dataTa="cancel-subscription-confirm"
		confirmDataTa="cancel-subscription-confirm-button"
		cancelDataTa="cancel-subscription-cancel-button"
		onConfirm={ onConfirm }
		onClose={ onClose }
		{ ...rest }
	/>
);

CancelSubscriptionConfirmDialog.propTypes = {
	artistName: PropTypes.string.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onConfirm: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default CancelSubscriptionConfirmDialog;
